import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

import { Stage, Layer, Line } from "react-konva";

import Checkbox from "./Checkbox";

function ChapitreContent(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  let navigate = useNavigate();

  useEffect(() => {
    appDispatch({
      type: "CLEAR_ALL_CANVAS",
      value: false,
    });
  }, []);

  function handleRetourClick() {
    appDispatch({ type: "CLEAR_ALL_CANVAS", value: true });
    appDispatch({
      type: "SET_SCROLL_TO",
      value: parseInt(props.chapitreId),
    });
    navigate(`/`, { replace: false });
  }

  function handleCleClick() {
    appDispatch({ type: "CLEAR_ALL_CANVAS", value: true });
    navigate(`cle/`, { replace: false });
  }

  function handleMediaClick(url, type) {
    appDispatch({
      type: "OPEN_MEDIA_PLAYER",
      mediaType: type,
      mediaSrc: url,
    });
  }

  function openReinitChapterModal() {
    appDispatch({
      type: "OPEN_REINIT_CHAPTER_MODAL",
      value: props.chapitreIdx,
    });
  }

  return (
    <>
      <section className="section-pause">
        {props.pauses.map((pause, pauseIdx) => (
          <div key={pauseIdx} className="section-pause__container">
            <h2 className="section-pause__title">Halte {pause.id}</h2>
            <Stage
              className="section-pause__path"
              width={appState.canvasClear === true ? 1 : window.innerWidth}
              height={appState.canvasClear === true ? 1 : 60}
            >
              <Layer>
                <Line
                  x={0}
                  y={0}
                  points={[
                    window.innerWidth / 2,
                    15,
                    window.innerWidth / 2,
                    50,
                  ]}
                  dash={[0.001, 24]}
                  stroke={"#A6CE39"}
                  strokeWidth={8}
                  lineJoin="round"
                  lineCap="round"
                />
              </Layer>
            </Stage>
            <ul>
              {pause.contenus.map((contenu, contenuIdx) => (
                <>
                  <li
                    key={contenuIdx}
                    className={`box ${contenu.type} ${
                      contenu.url === "#" ? "a-venir" : ""
                    }`}
                  >
                    <h3>{contenu.titre}</h3>
                    <p>
                      {contenu.url !== "#" ? (
                        <a
                          className="stretched-link"
                          href={
                            contenu.type === "audio" || contenu.type === "video"
                              ? null
                              : contenu.url
                          }
                          target={
                            contenu.type === "audio" || contenu.type === "video"
                              ? null
                              : "_blank"
                          }
                          onClick={
                            contenu.type === "audio" || contenu.type === "video"
                              ? () =>
                                  handleMediaClick(contenu.url, contenu.type)
                              : null
                          }
                          rel="referrer"
                          dangerouslySetInnerHTML={{ __html: contenu.texte }}
                        ></a>
                      ) : (
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                              contenu.texte +
                              ` <span class="badge bg-primary">à venir</span>`,
                          }}
                        ></span>
                      )}
                    </p>
                    <Checkbox
                      chapitreIdx={props.chapitreIdx}
                      pauseIdx={pauseIdx}
                      contenuIdx={contenuIdx}
                    />
                  </li>
                  {pauseIdx + 1 >= props.pauses.length &&
                  contenuIdx + 1 >= pause.contenus.length ? (
                    <Stage
                      className="section-pause__path"
                      width={
                        appState.canvasClear === true ? 1 : window.innerWidth
                      }
                      height={appState.canvasClear === true ? 1 : 140}
                    >
                      <Layer>
                        <Line
                          x={0}
                          y={0}
                          points={[
                            window.innerWidth / 2,
                            20,
                            window.innerWidth / 2,
                            130,
                          ]}
                          dash={[0.001, 24]}
                          stroke={
                            appState.status[props.chapitreIdx].pauses[pauseIdx]
                              .contenus[contenuIdx].locked
                              ? "#B4B4B4"
                              : "#A6CE39"
                          }
                          strokeWidth={8}
                          lineJoin="round"
                          lineCap="round"
                        />
                      </Layer>
                    </Stage>
                  ) : (
                    <Stage
                      className="section-pause__path"
                      width={
                        appState.canvasClear === true ? 1 : window.innerWidth
                      }
                      height={appState.canvasClear === true ? 1 : 60}
                    >
                      <Layer>
                        <Line
                          x={0}
                          y={0}
                          points={[
                            window.innerWidth / 2,
                            20,
                            window.innerWidth / 2,
                            50,
                          ]}
                          dash={[0.001, 24]}
                          stroke={
                            appState.status[props.chapitreIdx].pauses[pauseIdx]
                              .contenus[contenuIdx].locked
                              ? "#B4B4B4"
                              : "#A6CE39"
                          }
                          strokeWidth={8}
                          lineJoin="round"
                          lineCap="round"
                        />
                      </Layer>
                    </Stage>
                  )}
                </>
              ))}
            </ul>
          </div>
        ))}
      </section>

      <footer className="page-footer chapitre-footer">
        <div>
          <button
            onClick={handleRetourClick}
            className="btn btn-standard btn-retour"
          >
            Retour
          </button>
        </div>
        <div>
          <button
            onClick={handleCleClick}
            className="btn btn-play btn-expedition"
          >
            Expédition
            <br />
            réussie&nbsp;!
          </button>
        </div>
        <div>
          <button
            className="btn btn-standard btn-reinit"
            onClick={openReinitChapterModal}
          >
            Réinitialiser
          </button>
        </div>
      </footer>
    </>
  );
}

export default ChapitreContent;
